import he from 'he';
import fp from 'lodash/fp';
import React from 'react';
import { Button, Col, Grid, Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import { LinkContainer } from 'react-router-bootstrap';
import { lifecycle, withHandlers, withProps } from 'recompose';
import { bindActionCreators, compose } from 'redux';
import { qualificationDocumentTypes, routes } from '../../../../../constants';
import { businessActions } from '../../../../../state/modules/business';
import { userActions } from '../../../../../state/modules/user';
import { noCapMap } from '../../../../../utils';
import { Icon, InputFormField, SelectFormField, TextAreaFormField } from '../../../../components';

const BusinessUserQualificationDetail = ({
  documentName,
  description,
  documentType,
  existingFiles,
  qualification,
  userId,
  approve
}) => {

  return <Grid id='qualification-detail'>
    <h1 className='text-center'>
      <Icon icon='content-large' /> Qualification Detail
    </h1>

    <Row className='md-gutter'>
      <Col xs={12} md={8} mdOffset={2} className='boxed text-left'>
        <form>
          <Row className='top-gap'>
            <Col xs={12}>
              <SelectFormField
                label='Document Type'
                disabled
                value={documentType}
                emptyOption={true}>
                {
                  fp.flow(
                    fp.values,
                    fp.map(({ name, label }) =>
                      <option key={name} value={name}>
                        {label}
                      </option>
                    )
                  )(qualificationDocumentTypes)
                }
              </SelectFormField>
            </Col>
          </Row>

          {
            fp.isEmpty(documentType) ? null :
              <Row>
                <Col xs={12}>
                  <InputFormField {...{
                    label: 'Document Name',
                    disabled: true,
                    value: documentName,
                  }} />
                </Col>
              </Row>
          }

          {
            fp.isEmpty(documentType) ? null :
              <Row>
                <Col xs={12}>
                  <TextAreaFormField {...{
                    label: 'Description (optional)',
                    disabled: true,
                    value: description,
                    required: true
                  }} />
                </Col>
              </Row>
          }

          {
            fp.isEmpty(documentType) ? null : [
              <Row key='upload-document-title' className='top-gap'>
                <Col xs={12}>
                  <p>Uploaded Documents</p>
                </Col>
              </Row>,
              noCapMap(
                ({ url, internalFileName }, index) => {
                  return <Row key={`existing-files-${index}`} className='no-gutter qualification-document-upload'>
                    <Col xs={10} xsOffset={1}>
                      <a href={he.decode(url)} className='flex-center linkBox' target="_blank">
                        {internalFileName}
                      </a>
                    </Col>
                  </Row>
                }
              )(existingFiles)
            ]
          }

          {
            fp.get('approved')(qualification) ?
              <Row>
                <Col xs={12} className='top-gap'>
                  <LinkContainer className='full' to={routes.app.teams.userProfiles(userId)}>
                    <Button bsStyle='plain'>Back</Button>
                  </LinkContainer>
                </Col>
              </Row> :
              <Row>
                <Col xs={12} className='top-gap'>
                  <Button className='full' onClick={approve}>Approve</Button>
                </Col>
                <Col xs={12} className='top-gap'>
                  <LinkContainer className='full' to={routes.app.teams.userProfiles(userId)}>
                    <Button bsStyle='plain'>Back</Button>
                  </LinkContainer>
                </Col>
              </Row>
          }


        </form>
      </Col>
    </Row>
  </Grid>
}

const mapStateToProps = (state) => ({
  qualifications: state.business.user.qualifications
})
const mapDispatchToProps = (dispatch) => ({
  getQualifications: bindActionCreators(businessActions.business.user.getQualifications, dispatch),
  approve: bindActionCreators(userActions.user.approveQualification, dispatch)
})

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withProps(
    ({
      match: {
        params: {
          qualificationId,
          businessId,
          userId
        }
      }
    }) => ({
      qualificationId: parseInt(qualificationId, 10),
      businessId: parseInt(businessId, 10),
      userId: parseInt(userId, 10)
    })
  ),
  withProps(
    ({ qualifications, qualificationId }) => {
      const qualification = fp.flow(
        fp.find(
          ({ id }) => id === qualificationId
        )
      )(qualifications)
      return {
        qualification
      }
    }
  ),
  withProps(
    ({ qualification }) => ({
      documentName: qualification ? qualification.name : '',
      description: qualification ? qualification.description : '',
      documentType: qualification ? qualification.qualificationType : '',
      existingFiles: qualification ? qualification.attachments : []
    })
  ),
  lifecycle({
    componentDidMount(prevProps) {
      const { businessId, userId, getQualifications } = this.props
      getQualifications(businessId, userId)
    }
  }),
  withHandlers({
    approve: ({ approve, businessId, userId, qualificationId }) => () => {
      approve(businessId, userId, qualificationId)
    }
  })
)(BusinessUserQualificationDetail)


// WEBPACK FOOTER //
// ./src/containers/pages/app/professional-profile/qualifications/business-user-qualification-detail.js